<template>
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button @click="cerrarModalNuevoEvento();">
          <ion-icon slot="icon-only"  name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>NUEVO EVENTO</ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content>
  
    <div class="container-fluid mt-3">
      <div class="row">
        <div class="col-12 text-secondary">
          Origen de la falla
        </div>
        
        <div class="col-12">
          <ion-item>
            <ion-select ok-text="ACEPTAR" cancel-text="CANCELAR" :interface-options="selectOrigenFalla" interface="action-sheet" placeholder="Seleccione opción.." @ionChange="dejarObservaciones=false;dejarImagenes=false;listarEventosHijo(tipoFalla.tev_id, 1);tiposubFalla1='';tiposubFalla2='';tiposubFalla3='';" v-model="tipoFalla">
              <ion-select-option :key ="index" v-for="(tipo, index) in tiposDeFalla" :value="tipo" v-text="tipo.tev_tipo"></ion-select-option>
            </ion-select>
          </ion-item>
        </div>
      </div>

      <div v-if="tieneHijos1" class="row mt-4">
        <div class="col-12 text-secondary">
          Subcategoría 1
        </div>
        <div class="col-12">
          <ion-item>
            <ion-select interface="action-sheet" cancel-text="CANCELAR" ok-text="ACEPTAR" placeholder="Seleccione opción.." @ionChange="dejarObservaciones=false;dejarImagenes=false;listarEventosHijo(tiposubFalla1.tev_id, 2);tiposubFalla2='';tiposubFalla3='';" v-model="tiposubFalla1">
              <ion-select-option :key ="index" v-for="(tipo, index) in tiposDeSubfalla1" :value="tipo" v-text="tipo.tev_tipo"></ion-select-option>
            </ion-select>
          </ion-item>
        </div>
      </div>

      <div v-if="tieneHijos2" class="row mt-4">
        <div class="col-12 text-secondary">
          Subcategoría 2
        </div>
        <div class="col-12">
          <ion-item>
            <ion-select interface="action-sheet" cancel-text="CANCELAR" ok-text="ACEPTAR" placeholder="Seleccione opción.." @ionChange="dejarObservaciones=false;dejarImagenes=false;listarEventosHijo(tiposubFalla2.tev_id, 3);tiposubFalla3='';" v-model="tiposubFalla2">
              <ion-select-option :key ="index" v-for="(tipo, index) in tiposDeSubfalla2" :value="tipo" v-text="tipo.tev_tipo"></ion-select-option>
            </ion-select>
          </ion-item>
        </div>
      </div>


      <div v-if="tieneHijos3" class="row mt-4">
        <div class="col-12 text-secondary">
          Subcategoría 3
        </div>
        <div class="col-12">
          <ion-item>
            <ion-select interface="action-sheet" cancel-text="CANCELAR" ok-text="ACEPTAR" placeholder="Seleccione opción.."  v-model="tiposubFalla3">
              <ion-select-option :key ="index" v-for="(tipo, index) in tiposDeSubfalla3" :value="tipo" v-text="tipo.tev_tipo"></ion-select-option>
            </ion-select>
          </ion-item>
        </div>
      </div>

      <div v-if="dejarObservaciones" class="row mt-4">
        <div class="col-12 text-secondary">
          Observaciones:
        </div>
        <div class="col-12">
          <ion-textarea rows="5" cols="20" v-model="observaciones" placeholder="Escriba aquí..."></ion-textarea>
        </div>
      </div>

      <div v-if="dejarImagenes" class="row mt-2">
        <div class="col-12 d-flex align-items-center">
          <ion-toggle class="pl-0" v-model="incluyeImagenes" @ionChange="imagenesEvento=[];imagenes=[];" color="secondary"></ion-toggle> 
          <span class="text-secondary">Incluir imagenes</span>
          <span v-if="incluyeImagenes" class=" ml-3 text-success">SÍ</span>
          <span v-else class="ml-3 text-danger">NO</span>
        </div>
      </div>

      <div v-if="incluyeImagenes" class="row mt-2 justify-content-center">
        <div class="col-6 text-center px-1">
          <ion-button @click="subirImagen()" color="primary" shape="round" fill="outline"><fa icon="image-polaroid" type="fad" class="fa-fw mr-1"></fa>SUBIR FOTO</ion-button>
        </div>
        <div v-if="esMovil" class="col-6 text-center px-0">
          <ion-button @click="tomarImagen()" color="primary" shape="round" fill="outline"><fa icon="camera" type="fad" class="fa-fw mr-1"></fa>TOMAR FOTO</ion-button>
        </div>
        <div class="col-12 text-center">
          <!-- ACA IRIAN LAS FOTOS -->
          <div v-if="imagenes.length>0" class="row mb-2 justify-content-center">
            <div class="col-3 mx-1 mt-2 pb-3 shadow-sm" :id="'foto'+index" :key="foto" v-for="(foto, index) in imagenes">
              <div class="cursor-pointer" @click.stop.prevent="eliminaFoto('foto'+index, index);">
                <fa icon="times-square" type="fas" class="my-2 float-left text-danger"></fa>
              </div>
              <img :src="foto.webviewPath">
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-3" v-if="cargandoDatos">
        <div class="col text-center">
          <ion-spinner  class="align-middle" name="lines"></ion-spinner> 
          <span class="text-secondary ml-2">CARGANDO...</span>
        </div>
      </div>

    </div>
  </ion-content>
  <ion-footer>
    <div class="row mx-2 mb-1 mt-1">
      <div class="col-6">
        <ion-button color="danger" @click="cerrarModalNuevoEvento()" expand="block" shape="round">CERRAR</ion-button>
      </div>
      <div class="col-6">
        <ion-button @click="guardarNuevoEvento();" color="success" expand="block" shape="round"
        :disabled="
          tipoFalla=='' || 
          (tieneHijos1 && tiposubFalla1 == '') ||
          (tieneHijos2 && tiposubFalla2 == '') ||
          (tieneHijos3 && tiposubFalla3 == '') || 
          observaciones == '' || 
          (incluyeImagenes && imagenes.length==0)" 
        >ACEPTAR</ion-button>
      </div>
    </div>
  </ion-footer>
</template>

<script>
import { IonContent,  IonFooter, IonSpinner, IonIcon, IonToggle, IonHeader, IonTitle, IonToolbar, IonButtons, IonButton, IonTextarea,IonItem, IonSelect, IonSelectOption, modalController, loadingController, alertController,toastController } from '@ionic/vue';
import { defineComponent      } from 'vue';
import { Preferences          } from '@capacitor/preferences';
import { addIcons             } from 'ionicons';
import { arrowBackOutline     } from 'ionicons/icons';
import { tomarFoto, subirFoto } from '@/plugins/usarCamara';
import { cerrarSesion         } from '@/plugins/funciones.ts';
import rutaBase                 from '@/plugins/variables';
import axios                    from 'axios';
import * as $                   from "jquery";

export default defineComponent({
  name: 'Modal',
  components: { IonContent, IonFooter, IonSpinner, IonIcon, IonToggle, IonHeader, IonTitle, IonToolbar, IonTextarea, IonButtons, IonButton, IonItem, IonSelect, IonSelectOption},
  props: {
    esMovil     : Boolean
  },
  setup(){
    const selectOrigenFalla = {
      header: 'ORIGEN DE LA FALLA',
    };

    return {
      selectOrigenFalla
    } 
  },
  data() {
    return {
      content             : 'Content',
      dato                : true,
      tipoFalla           : '',
      tiposubFalla1       : '',
      tiposubFalla2       : '',
      tiposubFalla3       : '',
      observaciones       : '',
      tiposDeFalla        : [],
      tiposDeSubfalla1    : [],
      tiposDeSubfalla2    : [],
      tiposDeSubfalla3    : [],
      tieneHijos1         : false,
      tieneHijos2         : false,
      tieneHijos3         : false,
      cargandoDatos       : true,
      dejarObservaciones  : false,
      dejarImagenes       : false,
      incluyeImagenes     : false,
      imagenesEvento      : [],
      imagenes            : [],
      idImagenBorrar      : '',
      indiceImagenBorrar  : '',
      cargandoTodo        : null
    }
  },
  created() {
    addIcons({
      'arrow-back-outline'  : arrowBackOutline
    });
  },
  mounted(){
    this.listarTiposEventoPadre();

  },
  methods:{
    async cargandoDatosTotal() {
      this.cargandoTodo = await loadingController
        .create({
          cssClass: 'text-secondary',
          message: 'CARGANDO DATOS...',
          animated:false,
          mode:'md'
        });

      await this.cargandoTodo.present();
    },

    async guardarNuevoEvento(){
      await this.cargandoDatosTotal();
      await this.ajustaFotosCamara();
      const token       = await Preferences.get({ key: 'token_auth' });
      const rutPersona  = await Preferences.get({ key: 'rut' });
      const headers     = { headers: { 'Authorization': `${token.value}` } };
      const data  = new URLSearchParams();
      data.append('tipo_falla',     this.tipoFalla.tev_id);
      data.append('tipo_subfalla1', this.tiposubFalla1.tev_id);
      data.append('tipo_subfalla2', this.tiposubFalla2.tev_id);
      data.append('tipo_subfalla3', this.tiposubFalla3.tev_id);
      data.append('observaciones',  this.observaciones);
      data.append('rut_persona',    rutPersona.value);
      data.append('imagenes',       JSON.stringify(this.imagenesEvento));

      axios.post(rutaBase+'/normal/guardarNuevoEvento',data,headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        else{
          this.cargandoTodo.dismiss();
          if(resp.data == 1){
            this.cerrarModalNuevoEvento({respuesta:1});
          }
          else{
            this.cerrarModalNuevoEvento({respuesta:2});
          }
        }
      }).catch(() =>{
        this.cargandoTodo.dismiss();
        this.cerrarModalNuevoEvento({respuesta:3});

      });
    },

    async listarTiposEventoPadre(){
      this.cargandoDatos = true;
      const token       = await Preferences.get({ key: 'token_auth' });
      const rutPersona  = await Preferences.get({ key: 'rut' });
      const headers     = { headers: { 'Authorization': `${token.value}` } };
      const data  = new URLSearchParams();

      data.append('rut_persona',    rutPersona.value);

      axios.post(rutaBase+'/normal/listarTiposDeEventosPadre', data, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        else{
          this.tiposDeFalla = resp.data;
          this.cargandoDatos = false;
        }
      }).catch(() =>{
        console.log("ERROR");
        this.cargandoDatos = false;
      });
    },

    async listarEventosHijo(eventoPadre, tipoHijo){
      this.cargandoDatos = true;
      if(tipoHijo == 1) {
        this.tiposDeSubfalla1 = [];this.tiposDeSubfalla2 = [];this.tiposDeSubfalla3 = [];
        this.tieneHijos1= false;this.tieneHijos2= false;this.tieneHijos3= false;
      }
      if(tipoHijo == 2) {
        this.tiposDeSubfalla2 = [];this.tiposDeSubfalla3 = [];
        this.tieneHijos2= false;this.tieneHijos3= false;
      }
      if(tipoHijo == 3) {
        this.tiposDeSubfalla3 = [];
        this.tieneHijos3= false;
      }
      const token       = await Preferences.get({ key: 'token_auth' });
      const rutPersona  = await Preferences.get({ key: 'rut' });
      const headers     = { headers: { 'Authorization': `${token.value}` } };
      const data  = new URLSearchParams();
      data.append('tipo', eventoPadre);
      data.append('rut_persona',    rutPersona.value);
      axios.post(rutaBase+'/normal/listarTiposDeEventosHijos', data, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        else{
          const numHijos = resp.data.length;
          if(tipoHijo == 1) {this.tiposDeSubfalla1 = resp.data;this.tieneHijos1= numHijos > 0 ? true:false;}
          if(tipoHijo == 2) {this.tiposDeSubfalla2 = resp.data;this.tieneHijos2= numHijos > 0 ? true:false;}
          if(tipoHijo == 3) {this.tiposDeSubfalla3 = resp.data;this.tieneHijos3= numHijos > 0 ? true:false;}
          
          if(numHijos == 0) {this.dejarObservaciones=true;this.dejarImagenes=true;}
          this.cargandoDatos = false;
        }
      }).catch(() =>{
        this.cargandoDatos = false;
        this.muestraToast('ERROR AL CONECTARSE CON EL SERVIDOR.');
      });
    },

    async muestraToast(msj='') {
      const toast = await toastController
        .create({
          message: msj,
          duration: 2000,
          cssClass: 'text-center'
        })
      return toast.present();
    },

    cerrarModalNuevoEvento(respuesta=null){
      modalController.dismiss(respuesta);
    },


    /*************************************/
    /* FUNCIONES PARA MANEJO DE IMAGENES */
    /*************************************/
    async tomarImagen(){
      const foto = await tomarFoto();
      this.imagenes.push(foto);
    },

    async subirImagen(){
      const foto = await subirFoto();
      this.imagenes.push(foto);
    },

    async resizeImg(base64) {
      const ancho = 720;
      const alto  = 1280;
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      const deferred = $.Deferred();
      let escala = 0;
      $("<img>").attr("src", base64).on("load", function() {
          let width, height;
          if(this.width < this.height){
            width   = ancho;
            height  = alto;
          }else{
            width   = alto;
            height  = ancho;
          }
          if(width/this.width < height/this.height){
            escala = width/this.width;
          }else{
            escala = height/this.height;
          }
          canvas.width  = this.width*escala;
          canvas.height = this.height*escala;

          context.scale(escala, escala);
          context.drawImage(this, 0, 0);
          deferred.resolve(canvas.toDataURL());
      });
      return deferred.promise();
    },

    eliminaFoto(id,indice){
      console.log(id)
      console.log(indice)
      this.idImagenBorrar = id;
      this.indiceImagenBorrar = indice;
      this.muestraAlertEliminacion();
    },

    async muestraAlertEliminacion() {
      const alert = await alertController
        .create({
          cssClass: 'my-custom-class',
          header: 'Confirmar',
          message: '¿DESEA ELIMINAR LA IMAGEN SELECCIONADA?',
          buttons: [
            {
              text: 'CANCELAR',
              handler: () => {
                this.idImagenBorrar     = '';
                this.indiceImagenBorrar = '';
              },
            },
            {
              text: 'ACEPTAR',
              handler: () => {
                this.imagenes.splice(this.indiceImagenBorrar, 1)
                $("#"+this.idImagenBorrar).remove();
                this.idImagenBorrar     = '';
                this.indiceImagenBorrar = '';
              },
            },
          ],
        });
      return alert.present();
    },

    async ajustaFotosCamara(){
      const fotosCamara = [];
      this.imagenes.forEach( function(valor) {
        fotosCamara.push(valor.webviewPath)
      });
      for(let i=0;i<fotosCamara.length;i++){
        await this.resizeImg(fotosCamara[i]).then(img => {
          this.imagenesEvento.push(img);
        });
      }
    }
  },
});
</script>

<style>
ion-select {
  width: 100% !important;
  justify-content: center;
  text-align: left;
}

.textarea-wrapper{
  border:1px solid #c3c3c3 !important;
  border-radius: 3px !important;
}

#fotos_evento{
  padding-bottom: 30px !important;
}

#back-text{
  font-size: 0.8rem !important;
}

.cursor-pointer{
  cursor:pointer !important;
}
</style>